import React, { useEffect, useState } from 'react';
import classes from "./CategoryVideoPlay.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import VideoPlayer from '../components/Player/VideoPlayer';

const CategoryVideoPlay = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [data, setData] = useState([]);
    const [video, setVideo] = useState(null);

    useEffect(() => {
        if (location?.state) {
            setData(location?.state?.data?.filter(item => item?.id !== location?.state?.video?.id));
            setVideo(location?.state?.video);
        }
    }, [location]);

    console.log({ data, video });

    return (
        <>
            {
                video?.video_link &&
                <VideoPlayer src={video?.video_link} autoPlay={false} 
                name={video?.video_name}
                />
            }
        </>

    )
}

export default CategoryVideoPlay